"use strict";

exports.__esModule = true;
exports.getDefaultLayout = exports.LayoutChartSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _icons2 = require("./icons");
var _constants = require("../../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getDefaultLayout = exports.getDefaultLayout = function getDefaultLayout(numberOfItems) {
  if (numberOfItems === 2) {
    return _constants.LAYOUT_TWO_COLUMNS;
  } else if (numberOfItems === 3) {
    return _constants.LAYOUT_THREE_COLUMNS;
  }
  return "";
};
var LayoutChartSelector = exports.LayoutChartSelector = function LayoutChartSelector(props) {
  var _chartItems$props, _chartItems$props2;
  var path = props.path,
    elementEditor = props.elementEditor,
    _props$chartItems = props.chartItems,
    chartItems = _props$chartItems === void 0 ? {
      props: []
    } : _props$chartItems;
  var layouts = {
    twoColumns: {
      icon: _icons.IconNames.TWO_COLUMNS,
      label: _constants.LAYOUT_TWO_COLUMNS
    },
    twoRows: {
      icon: _icons2.layoutTwoRows,
      label: _constants.LAYOUT_TWO_ROWS
    },
    threeColumns: {
      icon: _icons2.layoutThreeColumns,
      label: _constants.LAYOUT_THREE_COLUMNS
    },
    threeRows: {
      icon: _icons2.layoutThreeRows,
      label: _constants.LAYOUT_THREE_ROWS
    },
    bottomRowTwoTiles: {
      icon: _icons2.layoutBottomRowTwoTiles,
      label: _constants.LAYOUT_BOTTOM_ROW_TWO_TILES
    },
    leftColumnTwoTiles: {
      icon: _icons2.layoutLeftColumnTwoTiles,
      label: _constants.LAYOUT_LEFT_COLUMN_TWO_TILES
    },
    rightColumnTwoTiles: {
      icon: _icons2.layoutRightColumnTwoTiles,
      label: _constants.LAYOUT_RIGHT_COLUMN_TWO_TILES
    },
    topRowTwoTiles: {
      icon: _icons2.layoutTopRowTwoTiles,
      label: _constants.LAYOUT_TOP_ROW_TWO_TILES
    }
  };
  var renderButtons = function renderButtons(availableLayouts) {
    return availableLayouts.map(function (layout) {
      return /*#__PURE__*/_react["default"].createElement(_core.Button, {
        key: layout.label,
        icon: layout.icon,
        "data-testid": "LayoutChartSelector." + layout.label + ".button",
        intent: (chartItems == null ? void 0 : chartItems.layout) === layout.label ? _core.Intent.PRIMARY : null,
        onClick: function onClick() {
          return elementEditor.modifyElementAt(path, function (el) {
            return {
              item: "el.props.chartItems.layout",
              value: el.props.chartItems.layout = layout.label
            };
          });
        }
      });
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "LayoutChartSelector",
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginBottom: "5px"
    }
  }, ((_chartItems$props = chartItems.props) == null ? void 0 : _chartItems$props.length) === 2 && renderButtons([layouts.twoColumns, layouts.twoRows]), ((_chartItems$props2 = chartItems.props) == null ? void 0 : _chartItems$props2.length) === 3 && renderButtons([layouts.threeColumns, layouts.threeRows, layouts.bottomRowTwoTiles, layouts.leftColumnTwoTiles, layouts.rightColumnTwoTiles, layouts.topRowTwoTiles]));
};